import { useUser } from '@/lib/auth';
import {
  useDeclareOwnership,
  useNavigationPathLabel,
} from '@/shared/modules/navigation-path';

/**
 * 프로필 화면의 좌측 메뉴 선택. 길에 메뉴가 없으면 내 프로필이면 「내 퀴즈」, 아니면 「퀴즈 자료실」.
 * 로그인 확인 전에는 null 로 두어 메뉴·목록 버튼이 아무것도 고르지 않는다.
 * 여기서 연 화면의 목록 버튼이 「○○님 프로필」을 보이도록 사용자 이름을 등록한다.
 * userHashId 는 퀴즈 작성자 id(quizUserId)와 같은 값이다.
 */
export const useProfileSidebarMenu = (
  userHashId: string,
  username: string | undefined,
  /** 이 화면 주소(쿼리 없이). 여기로 돌아오는 목록 버튼이 사용자 이름을 붙인다. */
  location: string,
) => {
  const { user, isInitialized } = useUser();
  useDeclareOwnership(isInitialized ? user?.quizUserId === userHashId : null);
  useNavigationPathLabel(location, username);
};
